export default "__VITE_ASSET__C0qCRR93__"